import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import User from "./user.js"
import Tabs from "./tabs.js"
import Library from "./library.js"

export default new Vuex.Store({
	state: {
		width:0,
		height:0
	},
	getters:{
		getsize(state){
			return {
				width:state.width,
				height:state.height
			}
		}
	},
	mutations: {
		setsize(state){
			state.width= window.innerWidth
			if(state.width<1300){state.width=1300}
			state.height=window.innerHeight
			if(state.height<600){state.height=600}
		}
	},
	actions: {
	},
	modules: {
		User,
		Tabs,
		Library
	}
})
